import BaseInputWrapper from "./BaseInputWrapper.vue";

export default BaseInputWrapper;
